import React from "react";
import { Box, Container, Fade, Stack } from "@mui/material";
import MyPanel from "../../components/myPanel";
import MyLabel from "../../components/myLabel";
import MyInput from '../../components/myInput';
import MyButton from '../../components/myButton'
import MyLoading from '../../components/myLoading';
import backgroundPNG from '../../assets/imgs/background.png'
import useLoginState from "../../hooks/useLoginState";

const Login = () => {

    const {login, senha, empresa, submit} = useLoginState()
    
    const handleKeyPress = (event) => {
        if (event.key === "Enter") {
            submit.set();  // Trigger the login process when Enter is pressed
        }
    };    

    return (
    <Fade in={true} timeout={500}>
        <Box sx={{
                    height: "100vh",
                    width: "100vw",
                    backgroundImage: `url(${backgroundPNG})`,
                    backgroundPosition: 'center center',
                    backgroundRepeat: 'no-repeat',
                    backgroundSize: 'contain'
                }}>
            <Container 
                sx={{
                    height: "100vh",
                    width: "100vw",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                }}>

                <MyLoading render={submit.value}/>
                <MyPanel sx={{maxWidth: '400px'} }>
                    <Stack spacing={5}>
                        <MyLabel component='h1' text='Login'/>
                        <MyInput icon='company' label='Empresa' type='text' value={empresa.value} onChange={(e)=>empresa.set(e.target.value)}/>
                        <MyInput icon='login' label='Usuário' type='text' value={login.value} onChange={(e)=>login.set(e.target.value)}/>
                        <MyInput icon='password' label='Senha' type='password' value={senha.value} onChange={(e)=>senha.set(e.target.value)} onKeyPress={handleKeyPress}/>
                        <MyButton onClick={()=>submit.set()} variant='contained' text='Login'/>
                    </Stack>
                </MyPanel>
            </Container>
        </Box>
    </Fade>
    
    )
}

export default Login;